import React, { Component } from 'react';
import { Form, Input, DatePicker, Select, Radio, Icon, Modal, Button } from 'antd';
import moment from 'moment';
import { connect } from '@souche-f2e/muji';
import { dispatch } from '@@/store';
import { RowCol } from '@/components';
import styles from '../_style/index.less';
import { CHECK_Money, CHECK_name, CHECK_Num } from '@/shared/reqexp';
import { range } from '@/shared/functions';
import styled from 'styled-components';
const FormDiv = styled.div `
  .test_form > div > .ant-row > .ant-col{
    padding-right: 3%;
    .ant-form-item-label{
    width:135px;
    margin-right: 10px;
    }
    .ant-form-item{
    display: flex;
   }
   .ant-form-item-control-wrapper{
      width:100%;
    }
    .ant-radio-wrapper{
    margin: 0;
    }
  }
  .ant-input-affix-wrapper .ant-input:not(:last-child){
    padding-right: 46px;
  }
`;
const mapStateToProps = (rootState) => ({
    session: rootState.session,
});
class SessionForm extends Component {
    constructor(props) {
        super(props);
        this.requestState = false;
        this.changeItem = 'all';
        this.hasMount = false;
        this.state = {
            maxSingle: 168,
            requestState: false,
            showDeposit: false,
            selectWidth: null,
        };
        this.changeSessionType = this.changeSessionType.bind(this);
        this.limitTime = this.limitTime.bind(this);
        this.limitDate = this.limitDate.bind(this);
        this.getSelctWidth = this.getSelctWidth.bind(this);
        this.limitDeadlineAuctionDate = this.limitDeadlineAuctionDate.bind(this);
        this.limitDeadlineAuctionTime = this.limitDeadlineAuctionTime.bind(this);
        this.dealDeadlineAuctionTime = this.dealDeadlineAuctionTime.bind(this);
        this.changeRule = this.changeRule.bind(this);
        this.judgeClearHasDel = this.judgeClearHasDel.bind(this);
    }
    getSelctWidth() {
        const $input = document.getElementsByClassName('hard_width')[0];
        const $selects = document.getElementsByClassName('hard_width_select');
        let i = 0;
        while (i < $selects.length) {
            const $select = $selects[i];
            if ($select.clientWidth !== $input.clientWidth) {
                $select.setAttribute('style', `width: ${$input.clientWidth}px;`);
            }
            i += 1;
        }
    }
    componentDidMount() {
        this.hasMount = true;
        window.addEventListener('resize', this.getSelctWidth);
        setTimeout(() => {
            this.getSelctWidth();
        }, 500);
    }
    componentWillUnmount() {
        window.removeEventListener('resize', this.getSelctWidth);
    }
    // desc 场次类型改变
    changeSessionType(sessionType) {
        this.props.form.resetFields(['auctionPlayRuleId']);
        this.getSelctWidth();
        dispatch.session.getPlayRuleList({
            auctionMode: sessionType,
            callback: () => {
                switch (sessionType) {
                    case 1:
                        break;
                    case 2:
                        dispatch.session.getPlayRule({
                            type: sessionType,
                            callback: () => {
                                this.forceUpdate();
                            },
                        });
                        break;
                    case 1001:
                        dispatch.session.getPlayRule({
                            type: sessionType,
                            callback: () => {
                                this.forceUpdate();
                            },
                        });
                        break;
                    case 1011:
                        dispatch.session.getPlayRule({
                            type: sessionType,
                            callback: () => {
                                this.forceUpdate();
                                this.dealDeadlineAuctionTime();
                            },
                        });
                        break;
                    case 1021:
                        this.requestState = true;
                        dispatch.session.getPlayRule({
                            type: sessionType,
                            callback: () => {
                                this.forceUpdate();
                            },
                        });
                        break;
                }
                this.props.form.resetFields([`singleCarAuctionDuration${sessionType}`, `carAuctionDuration${sessionType}`]);
            },
        });
    }
    // desc 限制竞拍时间（不得早于当前时间） - 除暗拍
    limitTime(selected) {
        const selectDate = selected ? selected : moment();
        let disabledHours = 0;
        let disabledMinutes = 0;
        const selest = selectDate.format('YYYY-MM-DD');
        const now = moment().format('YYYY-MM-DD');
        if (selest === now) {
            const selectHour = selectDate.hour();
            const nowHour = moment().hour();
            const nowMinute = moment().minute() + 1;
            disabledHours = nowHour;
            selectHour === nowHour && (disabledMinutes = nowMinute);
        }
        return {
            disabledHours: () => disabledHours ? range(0, disabledHours) : [],
            disabledMinutes: () => disabledMinutes ? range(0, disabledMinutes) : [],
            disabledSeconds: () => range(1, 60),
        };
    }
    // desc 限制竞拍日期（不得早于当前日期） - 除暗拍
    limitDate(current) {
        const currentDay = current.format('YYYY-MM-DD');
        const nowDay = moment().format('YYYY-MM-DD');
        return moment(currentDay).isBefore(nowDay);
    }
    // desc 禁用日期选择框的input输入
    banInput() {
        const dateDom = document.querySelector('.ban-input-date .ant-calendar-input') || null;
        const readOnlyState = dateDom ? dateDom.getAttribute('readonly') : undefined;
        !readOnlyState && setTimeout(() => {
            const dateDomNew = document.querySelector('.ban-input-date .ant-calendar-input') || null;
            dateDomNew && dateDomNew.setAttribute('readonly', 'true');
        });
    }
    // desc 超级拍-竞拍开始截止时间 = 竞拍开始时间 + 投标时长 + 24h
    dealDeadlineAuctionTime() {
        setTimeout(() => {
            const { preStartDate, carAuctionDuration1011 } = this.props.form.getFieldsValue(['preStartDate', 'carAuctionDuration1011', 'deadlineOfStartBidding']);
            if (preStartDate && carAuctionDuration1011) {
                let deadlineOfStartBiddingNew = moment(preStartDate).add(carAuctionDuration1011, 'h');
                deadlineOfStartBiddingNew = deadlineOfStartBiddingNew.add(24, 'h');
                deadlineOfStartBiddingNew = deadlineOfStartBiddingNew.add(1, 'm');
                this.props.form.setFieldsValue({
                    deadlineOfStartBidding: deadlineOfStartBiddingNew,
                });
            }
        });
    }
    // desc 超级拍-限制竞拍开始截止时间晚于暗拍截止时间
    limitDeadlineAuctionDate(current) {
        const { preStartDate, carAuctionDuration1011 } = this.props.form.getFieldsValue(['preStartDate', 'carAuctionDuration1011']);
        const darkDeadTime = carAuctionDuration1011 ? moment(preStartDate).add(carAuctionDuration1011, 'h') : preStartDate;
        const currentDay = current.format('YYYY-MM-DD');
        const deadTime = darkDeadTime.format('YYYY-MM-DD');
        return moment(currentDay).isBefore(deadTime);
    }
    limitDeadlineAuctionTime(selected) {
        const { preStartDate, carAuctionDuration1011 } = this.props.form.getFieldsValue(['preStartDate', 'carAuctionDuration1011']);
        const darkDeadTime = carAuctionDuration1011 ? moment(preStartDate).add(carAuctionDuration1011, 'h') : preStartDate;
        const selectDate = selected ? selected : moment();
        let disabledHours = 0;
        let disabledMinutes = 0;
        const selest = selectDate.format('YYYY-MM-DD');
        const deadTime = darkDeadTime.format('YYYY-MM-DD');
        if (selest === deadTime) {
            const selectHour = selectDate.hour();
            const nowHour = darkDeadTime.hour();
            const nowMinute = darkDeadTime.minute() + 1;
            disabledHours = nowHour;
            selectHour === nowHour && (disabledMinutes = nowMinute);
        }
        return {
            disabledHours: () => disabledHours ? range(0, disabledHours) : [],
            disabledMinutes: () => disabledMinutes ? range(0, disabledMinutes) : [],
            disabledSeconds: () => range(1, 60),
        };
    }
    // desc 保证金
    renderDeposit({ key, typeKey = 'frozenType', depositKey = 'roundDeposit' }) {
        const { getFieldDecorator, getFieldsValue } = this.props.form;
        const { formData, roundStatus, pageState } = this.props.session;
        const disabled = pageState === 2 || (roundStatus !== 0);
        return (<Form.Item label={<div style={{
            display: 'inline-block',
            alignItems: 'center',
        }}>
            保证金
            <Icon style={{
            color: '#999999',
            marginLeft: '5px',
            cursor: 'pointer',
        }} type="question-circle" theme="filled" onClick={() => {
            this.setState({
                showDeposit: true,
            });
        }}/>
          </div>} className={styles.form_layout} key={'sence_deposit'} style={{
            marginBottom: 0,
        }}>
        <div style={{
            display: 'flex',
            flexDirection: 'row',
        }}>
          {getFieldDecorator(typeKey, {
            initialValue: formData[typeKey],
            rules: [
                {
                    required: true,
                    message: '请选择保证金类型',
                },
            ],
        })(<Radio.Group className={styles.radio_group} disabled={disabled} style={{
            display: 'flex',
            flexDirection: 'row',
            marginTop: '9px',
        }}>
                <Radio value={1}>场次</Radio>
                <Radio value={2}>单车</Radio>
              </Radio.Group>)}
          <Form.Item label={''} className={styles.form_layout} style={{
            width: '100%',
        }} key={'sence_auction'}>
            {getFieldDecorator(depositKey, {
            initialValue: formData[depositKey],
            rules: [
                {
                    required: true,
                    message: '请填写保证金',
                },
                {
                    pattern: CHECK_Money,
                    message: '请填写正确格式的保证金',
                },
            ],
        })(<Input disabled={disabled} placeholder={'请填写'} suffix={<span style={{
            color: '#999999',
        }}>
                          元/{getFieldsValue(['frozenType']).frozenType === 1 ? '场' : '辆'}
                    </span>}/>)}
          </Form.Item>
        </div>
      </Form.Item>);
    }
    // desc 场次名称
    renderSessionName() {
        const { getFieldDecorator } = this.props.form;
        const { formData, roundStatus, pageState } = this.props.session;
        const disabled = pageState === 2 || (roundStatus !== 0);
        return (<Form.Item label={'场次名称'} className={styles.form_layout}>
        {getFieldDecorator('roundName', {
            initialValue: formData['roundName'],
            rules: [
                {
                    required: true,
                    message: '请填写场次名称',
                }, {
                    validator: CHECK_name(50),
                },
            ],
        })(<Input className={'hard_width'} disabled={disabled} placeholder={'请填写场次名称'}/>)}
      </Form.Item>);
    }
    // desc 判断选中规则是否已删除，待发拍页面 删除展示为空，已发拍页面展示Id
    judgeClearHasDel(val, list) {
        const { roundStatus } = this.props.session;
        if (roundStatus === 0) { // 待发拍
            const listValues = list.map((item) => `${item.id}`);
            if (!listValues.includes(val)) {
                return undefined;
            }
        }
        return val;
    }
    // desc 佣金规则
    renderRuleBrokerage() {
        const { getFieldDecorator } = this.props.form;
        const { formData, roundStatus, pageState, brokerageRuleList } = this.props.session;
        const disabled = pageState === 2 || (roundStatus !== 0);
        return (<Form.Item label={'佣金规则'} className={styles.form_layout}>
        {getFieldDecorator('brokerageRuleId', {
            initialValue: formData['brokerageRuleId'] ? this.judgeClearHasDel(formData['brokerageRuleId'], brokerageRuleList) : undefined,
            rules: [
                {
                    required: true,
                    message: '请选择佣金规则',
                },
            ],
        })(<Select className={'hard_width_select'} disabled={disabled} placeholder={'请选择佣金规则'} onChange={() => {
            this.changeRule();
        }} getPopupContainer={(triggerNode) => {
            return triggerNode.parentNode;
        }}>
              {brokerageRuleList.map((item, i) => (<Select.Option value={`${item.id}`} key={item.id}>
                    {item.ruleName}
                  </Select.Option>))}
            </Select>)}
      </Form.Item>);
    }
    // desc 服务费规则
    renderRuleCommission() {
        const { getFieldDecorator } = this.props.form;
        const { formData, roundStatus, pageState, commissionRuleList } = this.props.session;
        const disabled = pageState === 2 || (roundStatus !== 0);
        return (<Form.Item label={'服务费规则'} className={styles.form_layout}>
        {getFieldDecorator('commissionRuleId', {
            initialValue: formData['commissionRuleId'] ? this.judgeClearHasDel(formData['commissionRuleId'], commissionRuleList) : undefined,
            rules: [
                {
                    required: true,
                    message: '请选择服务费规则',
                },
            ],
        })(<Select className={'hard_width_select'} disabled={disabled} placeholder={'请选择服务费规则'} onChange={() => {
            this.changeRule();
        }} getPopupContainer={(triggerNode) => {
            return triggerNode.parentNode;
        }}>
              {commissionRuleList.map((item, i) => (<Select.Option value={`${item.id}`} key={item.id}>
                    {item.ruleName}
                  </Select.Option>))}
            </Select>)}
      </Form.Item>);
    }
    // desc 玩法规则
    renderRulePlay() {
        const { getFieldDecorator } = this.props.form;
        const { formData, roundStatus, pageState, playRuleList } = this.props.session;
        const disabled = pageState === 2 || (roundStatus !== 0);
        const defaultItem = playRuleList.filter((item) => item.defaultTag === 1);
        const defaultPlay = defaultItem.length > 0 ? `${defaultItem[0].id}` : undefined;
        console.log(formData);
        return (<Form.Item label={'玩法规则'} className={styles.form_layout}>
        {getFieldDecorator('auctionPlayRuleId', {
            initialValue: formData['auctionPlayRuleId'] ? this.judgeClearHasDel(formData['auctionPlayRuleId'], playRuleList) : defaultPlay,
            rules: [
                {
                    required: true,
                    message: '请选择玩法规则',
                },
            ],
        })(<Select className={'hard_width_select'} disabled={disabled} placeholder={'请选择玩法规则'} onChange={() => {
            this.changePlay();
        }} getPopupContainer={(triggerNode) => {
            return triggerNode.parentNode;
        }}>
              {playRuleList.map((item, i) => (<Select.Option value={`${item.id}`} key={item.id}>
                    {item.ruleName}
                  </Select.Option>))}
            </Select>)}
      </Form.Item>);
    }
    // desc 改变场次【佣金，服务费】规则
    changeRule() {
        setTimeout(() => {
            const { commissionRuleId, brokerageRuleId } = this.props.form.getFieldsValue(['commissionRuleId', 'brokerageRuleId']);
            dispatch.session.updateRule({
                params: {
                    brokerageRuleId,
                    commissionRuleId,
                },
                callback: ({ brokerageRuleId, commissionRuleId }) => {
                    this.props.form.setFieldsValue({
                        brokerageRuleId,
                        commissionRuleId,
                    });
                },
            });
        });
    }
    // desc 改变场次玩法规则 -> 获取单车拍卖时长，投标时长
    changePlay() {
        setTimeout(() => {
            const { auctionPlayRuleId, auctionMode } = this.props.form.getFieldsValue(['auctionPlayRuleId', 'auctionMode']);
            dispatch.session.changeAuctionRule({
                params: {
                    auctionPlayRuleId,
                },
                auctionMode,
                callback: ({ auctionPlayRuleId, carAuctionDuration, singleCarAuctionDuration }) => {
                    setTimeout(() => {
                        if (auctionPlayRuleId) {
                            this.props.form.setFieldsValue({
                                auctionPlayRuleId,
                            });
                        }
                        else {
                            this.props.form.resetFields([
                                `carAuctionDuration${auctionMode}`,
                                `singleCarAuctionDuration${auctionMode}`,
                            ]);
                        }
                    });
                },
            });
        });
    }
    // desc 场次地址
    renderSessionAddress() {
        const { getFieldDecorator } = this.props.form;
        const { formData, sessionAddress, roundStatus, pageState } = this.props.session;
        const disabled = pageState === 2 || (roundStatus !== 0);
        const roundAddressId = (formData['roundAddressId'] && formData['roundAddressId'] !== 'null') ? `${formData['roundAddress']}--${Number(formData['roundAddressId'])}` : undefined;
        return (<Form.Item label={'场次地址'} className={styles.form_layout}>
        {getFieldDecorator('roundAddressId', {
            initialValue: roundAddressId,
            rules: [
                {
                    required: true,
                    message: '请选择场次地址',
                },
            ],
        })(<Select className={'hard_width_select'} disabled={disabled} placeholder={'请选择场次地址'} getPopupContainer={(triggerNode) => {
            return triggerNode.parentNode;
        }}>
              {sessionAddress.map((v, i) => (<Select.Option value={`${v.roundAddress}--${v.id}`} key={v.key}>
                    {v.roundAddressNew}
                  </Select.Option>))}
            </Select>)}
      </Form.Item>);
    }
    // desc 场次类型
    renderSessionType() {
        const { getFieldDecorator } = this.props.form;
        const { formData, roundStatus, sessionList, pageState } = this.props.session;
        const disabled = pageState === 2 || (roundStatus !== 0);
        return (<Form.Item label={'场次类型'} className={styles.form_layout}>
        {getFieldDecorator('auctionMode', {
            initialValue: formData.auctionMode,
            rules: [
                {
                    required: true,
                    message: '请选择场次类型',
                },
            ],
        })(<Select getPopupContainer={(triggerNode) => {
            return triggerNode.parentNode;
        }} disabled={disabled} placeholder={'请选择场次类型'} onChange={this.changeSessionType}>
              {sessionList.map((v, i) => (<Select.Option value={Number(v.keyName)} key={i}>{v.value}</Select.Option>))}
            </Select>)}
      </Form.Item>);
    }
    // desc 现场拍
    renderScene() {
        const { getFieldDecorator } = this.props.form;
        const { formData, roundStatus, pageState } = this.props.session;
        const disabled = pageState === 2 || (roundStatus !== 0);
        return (<RowCol>
        {this.renderSessionType()}
        {this.renderSessionName()}
        <Form.Item label={'竞拍开始时间'} className={styles.form_layout}>
          {getFieldDecorator('preStartDate', {
            initialValue: formData['preStartDate'] ? moment(formData['preStartDate']) : undefined,
            rules: [
                {
                    required: true,
                    message: '请选择竞拍开始时间',
                },
                {
                    validator: (rule, value, callback) => {
                        if (!value || value.isAfter(moment())) {
                            callback();
                        }
                        else {
                            callback('竞拍开始时间不能早于当前时间');
                        }
                    },
                },
            ],
        })(<DatePicker key={'sence_time'} disabled={disabled} className={'width-100'} dropdownClassName={'ban-input-date'} onOpenChange={(isOpen) => {
            if (!isOpen) {
                return;
            }
            this.banInput();
        }} getCalendarContainer={(triggerNode) => {
            return triggerNode.parentNode;
        }} showToday={false} placeholder={'请选择竞拍开始时间'} disabledDate={this.limitDate} disabledTime={this.limitTime} showTime={{
            defaultValue: moment().set('second', 0),
            inputReadOnly: true,
        }}/>)}
        </Form.Item>
        {this.renderSessionAddress()}
        {this.renderDeposit({ key: 'car_deposit' })}
        {this.renderRuleBrokerage()}
        {this.renderRuleCommission()}
        {this.renderRulePlay()}
      </RowCol>);
    }
    // desc 暗拍
    renderDark() {
        const { getFieldDecorator } = this.props.form;
        const { formData, roundStatus, pageState, ruleDefaultConfig } = this.props.session;
        const { freezeDeposit } = ruleDefaultConfig.dark;
        const disabled = pageState === 2 || (roundStatus !== 0);
        return (<RowCol>
        {this.renderSessionType()}
        {this.renderSessionName()}
        <Form.Item label={'竞拍开始时间'} className={styles.form_layout} key={'dark_time'}>
          {getFieldDecorator('preStartDate', {
            validateFirst: true,
            initialValue: formData['preStartDate'] ? moment(formData['preStartDate']) : undefined,
            rules: [
                {
                    required: true,
                    message: '请选择竞拍开始时间',
                },
                {
                    validator: (rule, value, callback) => {
                        if (!value || value.isAfter(moment())) {
                            callback();
                        }
                        else {
                            callback('竞拍开始时间不能早于当前时间');
                        }
                    },
                },
                {
                    validator: (rule, value, callback) => {
                        if (this.changeItem === 'preStartDate') {
                            const endDate = this.props.form.getFieldsValue(['endTime'])['endTime'];
                            if (endDate) {
                                this.props.form.validateFields(['endTime']);
                                if (!value || value.isBefore(endDate)) {
                                    callback();
                                }
                                else {
                                    callback('竞拍开始时间需早于竞拍结束时间');
                                }
                            }
                            else {
                                callback();
                            }
                        }
                        else {
                            callback();
                        }
                    },
                },
                {
                    validator: (rule, value, callback) => {
                        if (this.changeItem === 'preStartDate') {
                            const { maxSingle } = this.state;
                            const endTime = this.props.form.getFieldsValue(['endTime'])['endTime'];
                            if (!endTime) {
                                callback();
                                return;
                            }
                            this.props.form.validateFields(['preStartDate']);
                            const hours = endTime.diff(value, 'h', true);
                            if (hours > maxSingle) {
                                callback('结束时间与开始时间间隔不可⼤于7*24h');
                            }
                            else {
                                callback();
                            }
                        }
                        else {
                            callback();
                        }
                    },
                },
            ],
        })(<DatePicker getCalendarContainer={(triggerNode) => {
            return triggerNode.parentNode;
        }} disabled={disabled} className={'width-100'} dropdownClassName={'ban-input-date'} onOpenChange={(isOpen) => {
            if (!isOpen) {
                return;
            }
            this.changeItem = 'preStartDate';
            this.banInput();
        }} showToday={false} placeholder={'请选择竞拍开始时间'} disabledDate={this.limitDate} disabledTime={this.limitTime} showTime={{
            defaultValue: moment().set('second', 0),
            inputReadOnly: true,
        }}/>)}
        </Form.Item>
        {this.renderSessionAddress()}
        {!freezeDeposit && this.renderDeposit({ key: 'dark_deposit' })}
        <Form.Item label={'竞拍结束时间'} className={styles.form_layout}>
          {getFieldDecorator('endTime', {
            validateFirst: true,
            initialValue: formData.endTime ? moment(formData.endTime) : undefined,
            rules: [
                {
                    required: true,
                    message: '请选择竞拍结束时间',
                },
                {
                    validator: (rule, value, callback) => {
                        if (!value || value.isAfter(moment())) {
                            callback();
                        }
                        else {
                            callback('竞拍结束时间需晚于当前时间');
                        }
                    },
                },
                {
                    validator: (rule, value, callback) => {
                        if (this.changeItem === 'endTime') {
                            const beginDate = this.props.form.getFieldsValue(['preStartDate'])['preStartDate'];
                            if (beginDate) {
                                this.props.form.validateFields(['preStartDate']);
                                if (!value || value.isAfter(beginDate)) {
                                    callback();
                                }
                                else {
                                    callback('竞拍结束时间需晚于竞拍开始时间');
                                }
                            }
                            else {
                                callback();
                            }
                        }
                        else {
                            callback();
                        }
                    },
                },
                {
                    validator: (rule, value, callback) => {
                        if (this.changeItem === 'endTime') {
                            const { maxSingle } = this.state;
                            const beginTime = this.props.form.getFieldsValue(['preStartDate'])['preStartDate'];
                            if (!beginTime) {
                                callback();
                                return;
                            }
                            this.props.form.validateFields(['preStartDate']);
                            const hours = value.diff(beginTime, 'h', true);
                            if (hours > maxSingle) {
                                callback('结束时间与开始时间间隔不可⼤于7*24h');
                            }
                            else {
                                callback();
                            }
                        }
                        else {
                            callback();
                        }
                    },
                },
            ],
        })(<DatePicker getCalendarContainer={(triggerNode) => {
            return triggerNode.parentNode;
        }} placeholder={'请选择竞拍结束时间'} dropdownClassName={'ban-input-date'} onOpenChange={(isOpen) => {
            if (!isOpen) {
                return;
            }
            this.changeItem = 'endTime';
            this.banInput();
        }} showToday={false} disabled={disabled} className={'width-100'} disabledDate={this.limitDate} disabledTime={this.limitTime} showTime={{
            defaultValue: moment().set('second', 0),
            inputReadOnly: true,
        }}/>)}
        </Form.Item>
        {this.renderRuleBrokerage()}
        {this.renderRuleCommission()}
        {this.renderRulePlay()}
      </RowCol>);
    }
    // desc 车道拍
    renderCar() {
        const { getFieldDecorator } = this.props.form;
        const { formData, roundStatus, pageState, ruleDefaultConfig } = this.props.session;
        const disabled = pageState === 2 || (roundStatus !== 0);
        const { singleCarAuctionDuration } = ruleDefaultConfig.car;
        return (<RowCol>
        {this.renderSessionType()}
        {this.renderSessionName()}
        <Form.Item label={'竞拍开始时间'} className={styles.form_layout}>
          {getFieldDecorator('preStartDate', {
            initialValue: formData['preStartDate'] ? moment(formData['preStartDate']) : undefined,
            rules: [
                {
                    required: true,
                    message: '请选择竞拍开始时间',
                },
                {
                    validator: (rule, value, callback) => {
                        if (!value || value.isAfter(moment())) {
                            callback();
                        }
                        else {
                            callback('竞拍开始时间不能早于当前时间');
                        }
                    },
                },
            ],
        })(<DatePicker key={'sence_time'} disabled={disabled} className={'width-100'} dropdownClassName={'ban-input-date'} onOpenChange={(isOpen) => {
            if (!isOpen) {
                return;
            }
            this.banInput();
        }} showToday={false} placeholder={'请选择竞拍开始时间'} disabledDate={this.limitDate} disabledTime={this.limitTime} showTime={{
            defaultValue: moment().set('second', 0),
            inputReadOnly: true,
        }} getCalendarContainer={(triggerNode) => {
            return triggerNode.parentNode;
        }}/>)}
        </Form.Item>
        <Form.Item label={'单车拍卖时长'} className={styles.form_layout}>
          {getFieldDecorator('singleCarAuctionDuration1001', {
            validateFirst: true,
            initialValue: formData['singleCarAuctionDuration'] || singleCarAuctionDuration,
            rules: [
                {
                    required: true,
                    message: '请输入单车拍卖时长',
                },
                {
                    pattern: new RegExp(/^\d+$/),
                    message: '请输入正整数',
                },
                {
                    validator: (rule, value, callback) => {
                        if (value <= 60 && value > 0) {
                            callback();
                        }
                        else {
                            callback('单车拍卖时长为正整数，最大60分钟');
                        }
                    },
                },
            ],
        })(<Input disabled={disabled} placeholder={'请输入单车拍卖时长'} suffix={<span style={{
            color: '#999999',
        }}>
                    分钟
                  </span>}/>)}
        </Form.Item>
        {this.renderSessionAddress()}
        {this.renderDeposit({ key: 'car_deposit' })}
        {this.renderRuleBrokerage()}
        {this.renderRuleCommission()}
        {this.renderRulePlay()}
      </RowCol>);
    }
    // desc 超级拍（现场拍）
    renderSuperScene() {
        const { getFieldDecorator } = this.props.form;
        const { formData, roundStatus, pageState, ruleDefaultConfig } = this.props.session;
        const disabled = pageState === 2 || (roundStatus !== 0);
        const { carAuctionDuration } = ruleDefaultConfig.superScene;
        return (<RowCol>
        {this.renderSessionType()}
        {this.renderSessionName()}
        <Form.Item label={'投标开始时间'} className={styles.form_layout}>
          {getFieldDecorator('preStartDate', {
            initialValue: formData['preStartDate'] ? moment(formData['preStartDate']) : undefined,
            rules: [
                {
                    required: true,
                    message: '请选择竞拍开始时间',
                },
                {
                    validator: (rule, value, callback) => {
                        if (!value || value.isAfter(moment())) {
                            callback();
                        }
                        else {
                            callback('竞拍开始时间不能早于当前时间');
                        }
                    },
                },
            ],
        })(<DatePicker key={'sence_time'} disabled={disabled} onChange={this.dealDeadlineAuctionTime} className={'width-100'} dropdownClassName={'ban-input-date'} onOpenChange={(isOpen) => {
            if (!isOpen) {
                return;
            }
            this.banInput();
        }} showToday={false} placeholder={'请选择竞拍开始时间'} disabledDate={this.limitDate} disabledTime={this.limitTime} showTime={{
            defaultValue: moment().set('second', 0),
            inputReadOnly: true,
        }} getCalendarContainer={(triggerNode) => {
            return triggerNode.parentNode;
        }}/>)}
        </Form.Item>
        <Form.Item label={'投标时长'} className={styles.form_layout}>
          {getFieldDecorator('carAuctionDuration1011', {
            validateFirst: true,
            initialValue: formData['carAuctionDuration'] || carAuctionDuration,
            rules: [
                {
                    required: true,
                    message: '请输入投标时长',
                },
                {
                    pattern: CHECK_Num,
                    message: '请输入正确投标时长（最多1位小数）',
                },
                {
                    validator: (rule, value, callback) => {
                        if (value <= 168 && value > 0) {
                            callback();
                        }
                        else {
                            callback('请输入投标时长，最大168小时');
                        }
                    },
                },
            ],
        })(<Input disabled={disabled} placeholder={'请输入单车拍卖时长'} onChange={this.dealDeadlineAuctionTime} suffix={<span style={{
            color: '#999999',
        }}>
                    小时
                  </span>}/>)}
        </Form.Item>
        <Form.Item label={'竞拍开始截止时间'} className={styles.form_layout}>
          {getFieldDecorator('deadlineOfStartBidding', {
            initialValue: formData['deadlineOfStartBidding'] ? moment(formData['deadlineOfStartBidding']) : undefined,
            rules: [
                {
                    required: true,
                    message: '竞拍开始截止时间',
                },
                {
                    validator: (rule, value, callback) => {
                        const { preStartDate, carAuctionDuration1011 } = this.props.form.getFieldsValue(['preStartDate', 'carAuctionDuration1011']);
                        const deadTime = moment(preStartDate).add(carAuctionDuration1011, 'h');
                        if (!value || value.isAfter(deadTime)) {
                            callback();
                        }
                        else {
                            callback('竞拍开始截止时间不得早于暗拍截止时间');
                        }
                    },
                },
            ],
        })(<DatePicker getCalendarContainer={(triggerNode) => {
            return triggerNode.parentNode;
        }} key={'super_sence_time'} disabled={disabled} className={'width-100'} dropdownClassName={'ban-input-date'} onOpenChange={(isOpen) => {
            if (!isOpen) {
                return;
            }
            this.banInput();
        }} showToday={false} placeholder={'请选择竞拍开始截止时间'} disabledDate={this.limitDeadlineAuctionDate} disabledTime={this.limitDeadlineAuctionTime} showTime={{
            defaultValue: moment().set('second', 0),
            inputReadOnly: true,
        }}/>)}
        </Form.Item>
        {this.renderSessionAddress()}
        {this.renderDeposit({ key: 'super_scene_deposit' })}
        {this.renderRuleBrokerage()}
        {this.renderRuleCommission()}
        {this.renderRulePlay()}
      </RowCol>);
    }
    // desc 超级拍（车道拍）
    renderSuperCar() {
        const { getFieldDecorator } = this.props.form;
        const { formData, roundStatus, pageState, ruleDefaultConfig } = this.props.session;
        const disabled = pageState === 2 || (roundStatus !== 0);
        const { carAuctionDuration, singleCarAuctionDuration } = ruleDefaultConfig.superCar;
        return (<RowCol>
        {this.renderSessionType()}
        {this.renderSessionName()}
        <Form.Item label={'投标开始时间'} className={styles.form_layout}>
          {getFieldDecorator('preStartDate', {
            initialValue: formData['preStartDate'] ? moment(formData['preStartDate']) : undefined,
            rules: [
                {
                    required: true,
                    message: '请选择投标开始时间',
                },
                {
                    validator: (rule, value, callback) => {
                        if (!value || value.isAfter(moment())) {
                            callback();
                        }
                        else {
                            callback('投标开始时间不能早于当前时间');
                        }
                    },
                },
            ],
        })(<DatePicker getCalendarContainer={(triggerNode) => {
            return triggerNode.parentNode;
        }} key={'sence_time'} disabled={disabled} className={'width-100'} dropdownClassName={'ban-input-date'} onOpenChange={(isOpen) => {
            if (!isOpen) {
                return;
            }
            this.banInput();
        }} showToday={false} placeholder={'请选择投标开始时间'} disabledDate={this.limitDate} disabledTime={this.limitTime} showTime={{
            defaultValue: moment().set('second', 0),
            inputReadOnly: true,
        }}/>)}
        </Form.Item>
        <Form.Item label={'投标时长'} className={styles.form_layout}>
          {getFieldDecorator('carAuctionDuration1021', {
            validateFirst: true,
            initialValue: formData['carAuctionDuration'] || carAuctionDuration,
            rules: [
                {
                    required: true,
                    message: '请输入投标时长',
                },
                {
                    pattern: CHECK_Num,
                    message: '请输入正确投标时长（最多1位小数）',
                },
                {
                    validator: (rule, value, callback) => {
                        if (value <= 168 && value > 0) {
                            callback();
                        }
                        else {
                            callback('投标时长为正整数，最大168小时');
                        }
                    },
                },
            ],
        })(<Input disabled={disabled} placeholder={'请输入投标时长'} suffix={<span style={{
            color: '#999999',
        }}>
                    小时
                  </span>}/>)}
        </Form.Item>
        <Form.Item label={'单车拍卖时长'} className={styles.form_layout}>
          {getFieldDecorator('singleCarAuctionDuration1021', {
            validateFirst: true,
            initialValue: formData['singleCarAuctionDuration'] || singleCarAuctionDuration,
            rules: [
                {
                    required: true,
                    message: '请输入单车拍卖时长',
                },
                {
                    pattern: new RegExp(/^\d+$/),
                    message: '请输入正整数',
                },
                {
                    validator: (rule, value, callback) => {
                        if (value <= 60 && value > 0) {
                            callback();
                        }
                        else {
                            callback('单车拍卖时长为正整数，最大60分钟');
                        }
                    },
                },
            ],
        })(<Input disabled={disabled} placeholder={'请输入单车拍卖时长'} suffix={<span style={{
            color: '#999999',
        }}>
                    分钟
                  </span>}/>)}
        </Form.Item>
        {this.renderSessionAddress()}
        {this.renderDeposit({ key: 'super_car_deposit' })}
        {this.renderRuleBrokerage()}
        {this.renderRuleCommission()}
        {this.renderRulePlay()}
      </RowCol>);
    }
    // desc 根据场次类型 展示
    renderForm() {
        this.hasMount && this.getSelctWidth();
        const { formData } = this.props.session;
        const { getFieldsValue } = this.props.form;
        const sessionType = getFieldsValue(['auctionMode']).auctionMode || formData.auctionMode;
        let formDom;
        switch (sessionType) {
            case 2:
                formDom = this.renderDark();
                break;
            case 1001:
                formDom = this.renderCar();
                break;
            case 1011:
                formDom = this.renderSuperScene();
                break;
            case 1021:
                formDom = this.renderSuperCar();
                break;
            default:
                formDom = this.renderScene();
        }
        return formDom;
    }
    render() {
        return (<React.Fragment>
        <FormDiv>
          <Form layout={'horizontal'} colon={false} labelAlign={'left'} className={'test_form'} labelCol={{
            span: 3,
        }}>
            {this.renderForm()}
          </Form>
        </FormDiv>
        <Modal visible={this.state.showDeposit} footer={null} title={'保证金规则'} width={700} onCancel={() => {
            this.setState({
                showDeposit: false,
            });
        }}>
          <div style={{
            display: 'flex',
            justifyContent: 'space-around',
        }}>
            <Icon type="exclamation-circle" theme="filled" style={{
            fontSize: '24px',
            color: '#FF571A',
            marginTop: '5px',
        }}/>
            <div>
              <div>场次：出价车商据场次进行保证金冻结，场次冻结以设置为准，足保车商场次中车辆均可出价。</div>
              <div>单车：出价车商据单车进行保证金冻结，单车冻结以设置为准，即每辆车车商出价的冻结标准。</div>
            </div>
          </div>
          <div style={{
            display: 'flex',
            justifyContent: 'flex-end',
        }}>
            <Button style={{
            backgroundColor: '#FF571A',
            color: '#FFFFFF',
            marginTop: '10px',
        }} onClick={() => {
            this.setState({
                showDeposit: false,
            });
        }}>
              确定
            </Button>
          </div>
        </Modal>
      </React.Fragment>);
    }
}
// @ts-ignore
export default connect(mapStateToProps)(SessionForm);
